import DetailHeader from "./DetailHeader";
import DrawerHeader from "./DrawerHeader";
import Dropdown from "./Dropdown";
import Secondary from "./Secondary";

export default {
  DetailHeader,
  DrawerHeader,
  Dropdown,
  Secondary
};
